// types.
import { LeadDetail } from '@domains/lead-detail/interfaces/interfaces';
import {
  BodyHermesCO,
  BodyHermesMX,
} from '@domains/hermes/interfaces/interfaces';
import { GeoreferencingOverrides } from '../interfaces/georeferencing.types';

export const buildChangeCoordinatesPayload = (
  leadDetail: LeadDetail,
  coordinates: google.maps.LatLngLiteral,
  email: string,
  country: string | undefined,
  overrides?: GeoreferencingOverrides
): BodyHermesCO | BodyHermesMX => {
  const basePayload = {
    property_deal_id: Number(leadDetail.id),
    agent: email,
    area: Number(leadDetail.property.area) || 0,
    room_num: overrides?.rooms ?? (Number(leadDetail.property.rooms) || 0),
    garage: Number(leadDetail.property.garage) || 0,
    elevator: overrides?.elevators ?? (Number(leadDetail.property.elevator) || 0),
    bath: Number(leadDetail.property.baths) || 0,
    half_bathroom: Number(leadDetail.property.half_baths) || 0,
    latitude: coordinates.lat,
    longitude: coordinates.lng,
    years_old: Number(leadDetail.property.antiquity) || 0,
    floor_num: Number(leadDetail.property.floor) || 0,
    land_area: Number(leadDetail.property.land) || 0,
    address: overrides?.address ?? leadDetail.location?.address ?? '',
    property_type_id:
      overrides?.propertyTypeId ?? (Number(leadDetail.property.property_type_id) || 0),
    price_type:
      leadDetail.pricing?.last_deal_business_status || 'initial_pricing',
    validations: false,
  };

  if (country === 'MX') {
    return {
      ...basePayload,
      country: 'MX',
      exterior_number: leadDetail.location?.exterior_number || '',
      mex_state_id: leadDetail.location?.state_id || '',
      zip_code: leadDetail.location?.zip_code || '',
    } as BodyHermesMX;
  } else {
    return {
      ...basePayload,
      country: 'CO',
      admin_price: Number(leadDetail.property.pricing?.admin_price) || 0,
      building_complex:
        overrides?.buildingComplex ?? leadDetail.location?.house_complex ?? '',
    } as BodyHermesCO;
  }
};
